import actions from "./actions";

const initState = {
    purchaseInventoryMessage: null,
    purchaseInventoryLoading: false,
    purchaseInventoryError: null,
    purchaseInventoryFResult: [],

    purchaseSimList: [],
    getPurchaseSimListLoading: false,
    getPurchaseSimListError: null,

    simList: [],
    getSimListLoading: false,
    getSimListError: null,

};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.PURCHASE_INVENTORY:
            return {
                ...state,
                purchaseInventoryMessage: null,
                purchaseInventoryLoading: true,
                purchaseInventoryError: null,
                purchaseInventoryFResult:[]
            };
        case actions.PURCHASE_INVENTORY_SUCCESS:
            return {
                ...state,
                purchaseInventoryLoading: false,
                purchaseInventoryMessage: action.message,
                purchaseInventoryError: null,
            };
        case actions.PURCHASE_INVENTORY_FAILED:
            return {
                ...state,
                purchaseInventoryLoading: false,
                purchaseInventoryError: action.payload.error,
                purchaseInventoryFResult:action.payload.fResult
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                purchaseInventoryMessage: null,
                purchaseInventoryError: null,
                 purchaseInventoryFResult:[]
            };

            case actions.GET_SIM_LIST:
                return {
                    ...state,
                    simList: [],
                    getSimListLoading: true,
                    getSimListError: null,
                };
            case actions.GET_SIM_LIST_SUCCESS:
                return {
                    ...state,
                    getSimListLoading: false,
                    simList: action.result,
                    getSimListError: null,
                };
            case actions.GET_SIM_LIST_FAILED:
                return {
                    ...state,
                    getSimListLoading: false,
                    getSimListError: action.error,
                };


        case actions.GET_PURCHASE_SIM_LIST:
            return {
                ...state,
                purchaseSimList: [],
                getPurchaseSimListLoading: true,
                getPurchaseSimListError: null,
            };
        case actions.GET_PURCHASE_SIM_LIST_SUCCESS:
            return {
                ...state,
                getPurchaseSimListLoading: false,
                purchaseSimList: action.result,
                getPurchaseSimListError: null,
            };
        case actions.GET_PURCHASE_SIM_LIST_FAILED:
            return {
                ...state,
                getPurchaseSimListLoading: false,
                getPurchaseSimListError: action.error,
            };
        default:
            return state;
    }
}
